export default "__VITE_ASSET__cc65f548__"